// src/ui/select/DropdownCaret.jsx
import React from "react";
import { components } from "react-select";

const DropdownCaret = (props) => {
  const { menuIsOpen } = props.selectProps;
  return (
    <components.DropdownIndicator {...props}>
      <span
        aria-hidden
        style={{
          display: "inline-block",
          width: 0,
          height: 0,
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "6px solid #62C776",
          transform: menuIsOpen ? "rotate(180deg)" : "none",
          transition: "transform 120ms ease",
          marginRight: 6,
          marginTop: 6,
        }}
      />
    </components.DropdownIndicator>
  );
};

export default DropdownCaret;
